import Vue from 'vue';
import Vuex from 'vuex';
import campaign from './modules/campaign';
import partner from './modules/partner';
import ui from './modules/ui';
import operation from './modules/operation';
import catalog from './modules/catalog';
import cms from './modules/cms';
import filters from './modules/filters';
import imagesBench from './modules/imagesBench';
import automaticPublication from './modules/automaticPublication';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production' || process.env.MODE_VUE_DEVTOOLS === 'enabled';
// Fix: No Vuex store detected https://github.com/vuejs/vue-devtools/issues/405
Vue.config.devtools = debug;
const store = new Vuex.Store({
  state: {
    error: null
  },
  mutations: {
    RESET_ERROR_PROPERTY(state) {
      state.error = null;
    },

    ERROR_OCCURRED(state, error) {
      state.error = error;
    }
  },
  modules: {
    campaign,
    operation,
    partner,
    ui,
    catalog,
    cms,
    filters,
    imagesBench,
    automaticPublication
  },
  strict: debug
});

export { store as default };
